import type {ApiCompetencyRow} from './workforceProfileApiTypes';

export const toPercentScore = (value: number | null | undefined): number | null => {
  if (value == null || Number.isNaN(value)) {
    return null;
  }

  if (value <= 1) {
    return Math.round(value * 100);
  }

  return Math.round(value);
};

export const rowsMetPercent = (rows: ApiCompetencyRow[] | undefined): number | null => {
  if (!rows?.length) {
    return null;
  }

  const metCount = rows.filter((row) => row.met).length;
  return Math.round((metCount / rows.length) * 100);
};

export const formatConfidence = (value: string | undefined): string | null => {
  if (!value) {
    return null;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};
